/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingJoinRequestResponse
 */
export interface PendingJoinRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof PendingJoinRequestResponse
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof PendingJoinRequestResponse
     */
    company_name: string;
    /**
     * 
     * @type {number}
     * @memberof PendingJoinRequestResponse
     */
    requested_timestamp: number;
}

/**
 * Check if a given object implements the PendingJoinRequestResponse interface.
 */
export function instanceOfPendingJoinRequestResponse(value: object): value is PendingJoinRequestResponse {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('company_name' in value) || value['company_name'] === undefined) return false;
    if (!('requested_timestamp' in value) || value['requested_timestamp'] === undefined) return false;
    return true;
}

export function PendingJoinRequestResponseFromJSON(json: any): PendingJoinRequestResponse {
    return PendingJoinRequestResponseFromJSONTyped(json, false);
}

export function PendingJoinRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingJoinRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'company_name': json['company_name'],
        'requested_timestamp': json['requested_timestamp'],
    };
}

export function PendingJoinRequestResponseToJSON(json: any): PendingJoinRequestResponse {
    return PendingJoinRequestResponseToJSONTyped(json, false);
}

export function PendingJoinRequestResponseToJSONTyped(value?: PendingJoinRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'company_name': value['company_name'],
        'requested_timestamp': value['requested_timestamp'],
    };
}

